// removed by extract-text-webpack-plugin
module.exports = {"container":"Notification__container___2zzdI","box":"Notification__box___3QTWe","message":"Notification__message___2FQk2","msgContainer":"Notification__msgContainer___2DZRg","error":"Notification__error___3FkCu","success":"Notification__success___2UTUY"};


/*****************
 ** WEBPACK FOOTER
 ** ./src/templates/Notification.less
 ** module id = 768
 ** module chunks = 0
 **/